import {css} from '@emotion/css';
import {colours, coloursV2, fonts, spacing} from '@fo/shared/styles/variables';

const styles = {
  field: (hasWarning: boolean, hasError: boolean): string => css`
    label: field;
    margin-bottom: ${spacing.S};

    ${hasWarning &&
    css`
      margin-left: calc(-1rem - 4px);
      padding-left: ${spacing.XXS};
      border-left: 4px solid ${colours.semantic.WARNING};
    `}

    ${hasError &&
    css`
      margin-left: calc(-1rem - 4px);
      padding-left: ${spacing.XXS};
      border-left: 4px solid ${colours.semantic.ERROR};
    `}
  `,

  input: (hasWarning = false, hasError = false, isDisabled = false): string => css`
    label: field__input;

    ${hasWarning &&
    css`
      border: 2px solid ${colours.semantic.WARNING};
    `}

    ${hasError &&
    css`
      border: 2px solid ${colours.semantic.ERROR};
    `}


    ${isDisabled &&
    css`
      background-color: ${colours.field.DISABLED};
    `}
  `,

  label: (isDisabled?: boolean): string => css`
    label: field__label;

    display: flex;
    align-items: center;
    margin-bottom: ${spacing.XXS};
    color: ${colours.font.BLACK};
    font-weight: ${fonts.weight.SEMI_BOLD};
    font-size: ${fonts.size.L};
    text-align: left;

    ${isDisabled &&
    css`
      color: ${colours.font.DISABLED};
    `}
  `,
  optionalMessage: css`
    label: field__optional;
    font-weight: ${fonts.weight.REGULAR};
    font-style: italic;
  `,

  assistiveText: (hasWarning = false, hasError = false, isDisabled = false): string => css`
    label: field__assistiveText;
    display: block;
    margin-bottom: ${spacing.XXS};
    color: ${colours.font.ASSISTIVE};
    font-size: 1.6rem;

    ${hasWarning &&
    css`
      color: ${colours.font.WARNING};
    `}

    ${hasError &&
    css`
      color: ${colours.semantic.ERROR};
      font-weight: ${fonts.weight.SEMI_BOLD};
    `}

    ${isDisabled &&
    css`
      color: ${colours.font.DISABLED};
    `}
  `,
  tooltip: css`
    label: field_tooltip;
    padding-left: ${spacing.XXXS};
    color: ${coloursV2.brand.secondary};
  `,
};

export default styles;
